import { render, staticRenderFns } from "./InfoMessageModal.vue?vue&type=template&id=2f7029dd&"
import script from "./InfoMessageModal.vue?vue&type=script&lang=js&"
export * from "./InfoMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7029dd')) {
      api.createRecord('2f7029dd', component.options)
    } else {
      api.reload('2f7029dd', component.options)
    }
    module.hot.accept("./InfoMessageModal.vue?vue&type=template&id=2f7029dd&", function () {
      api.rerender('2f7029dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/InfoMessageModal.vue"
export default component.exports